// @flow
import React from 'react'

import { FieldLabel } from '../index'
import { String } from '../_formFields'

const PhoneInput = (props) => {
  const { phoneNumberLabel, pushIsPristine, validationErrors, phoneNumber, onPhoneChange } = props
  return (
    <div key="PhoneApp-content">
      <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center">
        <div className="col-10 col-sm-4 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right">
          <FieldLabel id="phoneNumber" isRequired label={phoneNumberLabel} />
        </div>
        <div className="col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0">
          <String
            enabled
            id="phoneNumber"
            inputType="tel"
            isPristine={pushIsPristine}
            name="phoneNumber"
            onChange={onPhoneChange}
            prefix="policyHolder-"
            validationErrors={validationErrors}
            value={phoneNumber}
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(PhoneInput)
